module.exports = __webpack_public_path__ + "static/media/03-profiles.357990bd.png";